export default {
  namespaced: true,
}
